import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllLectureAnalysis } from "../api/api";
import { toast } from "react-toastify";
import { FiPlus } from "react-icons/fi";
import CustomRecordingHistory from "../ui/CustomHistoryCard";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";

function RecordingHistory() {
  const navigate = useNavigate();
  const [lectures, setLectures] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAnalysis, setSelectedAnalysis] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const fetchLectureAnalysis = async () => {
    try {
      const response = await getAllLectureAnalysis();
      if (response && response.data) {
        setLectures(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching lecture analysis:", error);
      toast.error("Failed to fetch lecture analysis data.");
    }
  };

  useEffect(() => {
    fetchLectureAnalysis();
  }, []);

  const handleSelectItem = (item) => {
    setSelectedAnalysis(JSON.parse(item?.analysis));
    setSelectedItem(item);
  };

  return (
    <>
      <div className="p-5">
        {/* Header */}
        <div className="modalHeading py-3 d-flex justify-content-between align-items-center">
          <h3 className="h4 m-0">Recording History</h3>
          <button
            className="mainBlue2 py-2 px-3"
            onClick={() => navigate("/AudioScreenMic")}
          >
            <FiPlus size={22} className="me-1" />
            Add Recording
          </button>
        </div>
        <CustomRecordingHistory
          data={lectures}
          handleSelectItem={handleSelectItem}
        />

        <Modal
          show={!!selectedItem}
          onHide={() => setSelectedItem(null)}
          size="lg"
          className="addToGroupModal"
        >
          {/* <Modal.Header closeButton>
            <Modal.Title>Lecture Analysis</Modal.Title>
          </Modal.Header> */}
          <Modal.Body>
            <div className="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
              <h3>Lecture Analysis</h3>
              <button className="modalCloseBtn" onClick={() => setSelectedItem(false)}><IoClose size={24} /></button>
            </div>
            {selectedItem ? (
              <div>
                <div className="d-flex flex-column mb-3">
                  <label className="cardSubtitle">Audio</label>
                  <audio controls>
                    <source
                      src={
                        "https://visionemptrack.greymatterz.com/" +
                        "/" +
                        selectedItem.audio_path
                      }
                      type="audio/mpeg"
                    />
                    Your browser does not support the audio element.
                  </audio>
                </div>
                <hr />
                <h5 className="cardSubtitle mb-2">Transcript</h5>
                <p className="card-text">
                  {selectedItem.transcript
                    ? isExpanded
                      ? selectedItem.transcript
                      : `${selectedItem.transcript.slice(0, 350)}...`
                    : "Information not provided"}
                    {selectedItem.transcript &&
                      selectedItem.transcript.length > 40 && (
                        <span
                          onClick={() => setIsExpanded((prev) => !prev)}
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            marginLeft: "5px",
                          }}
                        >
                          {isExpanded ? "Read less" : "Read more"}
                        </span>
                      )}
                </p>

                <div className="">
                  <h3 className="cardTitle">Lecture Information</h3>
                  <div className="">
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Rating Key Concepts
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Rating Key Concepts"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Rating Lecture Quality
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Rating Lecture Quality"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Rating Professor Tone and Style
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis[
                            "Rating Professor Tone and Style"
                          ] || "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Rating Questions Asked
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Rating Questions Asked"] || 0}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Rating Student Interaction
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Rating Student Interaction"] || 0}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Lecture Quality
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Lecture Quality"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Engagement Level
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Engagement Level"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Pace of Lecture
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Pace of Lecture"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Student Interaction
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Student Interaction"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Professor Tone and Style
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Professor Tone and Style"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Key Concepts
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Key Concepts"]?.length
                            ? selectedAnalysis["Key Concepts"]?.map(
                                (ehr) => ehr + ", "
                              )
                            : "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Questions Asked
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Questions Asked"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 my-3">
                        <h5 className="cardSubtitle mb-1">
                          Summary
                        </h5>
                        <p className="card-text">
                          {selectedAnalysis["Summary"] ||
                            "Information not provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p className="card-text">No transcript available.</p>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default RecordingHistory;
